import React, { Fragment, useEffect, useState } from "react";
import { Card, Col, Media, Row, Spinner } from "reactstrap";
import UserTicketsIcon     from "~/assets/images/lottery/user_tickets.png"
import PreviousWinnersIcon from "~/assets/images/lottery/winners.png"
import OverlayModal from "~/components/overlayModal";

import GuideIcon           from "~/assets/images/tournament/guide.png";
import Guide from "./BottomModals/Guide";
import RecordsWinners from "./BottomModals/Winners";
import Game from "~/services/games";
import classNames from "classnames";

const BreakTheRecord = ({gameId})=> {

  const [userScore    , setScore]  = useState(null);
  const [recordReward , setRecordReward] = useState(null);
  const [isClaimed , setClaimed] = useState(null);
  const [isRecordAvailable , setAvailable] = useState(null);
  const [record    , setRecord]  = useState(null);
  const [recordsWinners    , setRecordsWinners]  = useState([]);
  const [isLoading    , setIsLoading]  = useState(true);

  const [selectedView , setSelectedView] = useState({title: "", view: ""});
  const [overlayOpen  , setOverlayOpen]  = useState(false);

  useEffect(()=> {
    (async()=> {
      const recordData = await Game.getRecordData(gameId);
      if(recordData){
        setClaimed(recordData.claimedByUser);
        setAvailable(recordData.recordAvailable);
        setRecord(recordData.todaysRecord);
        setRecordReward(recordData.todaysReward)
        setScore(recordData.usersHighScore);
        setRecordsWinners(recordData.recordsWinners);
        setIsLoading(false);
      }
    })();
  }, [gameId]);

  const openModal = (item)=> {
    setSelectedView(modals[item]);
    setOverlayOpen(true);
  };

  const modals = {
    guide  : { title: "Guide"            ,  view: Guide   },
    winners: { title: "Previous winners" ,  view: RecordsWinners, props: {winners: recordsWinners} },
   };

   if(isLoading) return (<div className="text-center"><Spinner style={{width: "36px", height: "36px"}}></Spinner></div>)
  
  return (
    <div className="record-modal">
      <div className="break-record-box">

        <div className="record-reward">
          <p className="left"> <img src={UserTicketsIcon} /> {!isRecordAvailable && !isClaimed ? "Tommorow's Reward" : 'Reward' } </p>
          <p className="right"> {recordReward} </p>
        </div>

        {!isRecordAvailable && isClaimed &&
          <Fragment>
            <h3 className="text-success m-b-30 text-center"> Record break! </h3>
            <h5 className="claimed text-center">Congratulations, you are the record breaker for today! </h5>
          </Fragment>
        }
        {isRecordAvailable && !isClaimed &&
          <div className={classNames("record-to-break", {"m-b-30": !userScore })}><strong>Today's Record Score: {record}</strong></div>
        }
        {isRecordAvailable && !isClaimed && userScore && <div className="user-score">Your highest score:{userScore}</div>}

        {!isRecordAvailable && !isClaimed &&
          <Fragment>
            <h3 className="text-danger m-b-30 text-center"> Sorry! :( </h3>
            <h5 className="failed text-center">You are too late, the record was break!</h5>
          </Fragment>
        }
      </div>

      <Row className="m-t-10">
          <Col xs="6" onClick={()=> openModal('guide')} className="modal-info">
            <Card body>
              <Media body>
                <img src={GuideIcon} />
                <span>Guide</span>
              </Media>
            </Card>
          </Col>
          <Col xs="6" onClick={()=> openModal('winners')} className="modal-info">
            <Card body>
              <Media body>
                <img src={PreviousWinnersIcon} />
                <span>Winners</span>
              </Media>
            </Card>
          </Col>
      </Row>

      <OverlayModal bottom classBody="p-b-0" title={selectedView.title} opened={overlayOpen} onClose={()=>setOverlayOpen(false)}>
        { selectedView.title ?  <selectedView.view { ...selectedView.props } /> : null }
      </OverlayModal>

    </div>



    //   <hr className="m-b-40"/>



    //   {isRecordAvailable && !isClaimed &&
    //   <Fragment>
    //     <h5 className="text-center">Today's Record Score: <strong>{record}</strong></h5>
    //     <p className="text-center">
    //       {userScore ? <div>Your highest score: <strong>{userScore}</strong> </div>: ``}
    //       Be the first to break the record today and win: <strong>{recordReward} Points!</strong>
    //     </p>
    //   </Fragment>
    //   }
    // </div>


  );
};

export default BreakTheRecord;
